import catalogConfig from "@configs/catalogConfig";
import workspaceConfig from "@configs/workspaceConfig";

const workspaceEndpoint =
  typeof window === "undefined" && workspaceConfig.internal_ip
    ? workspaceConfig.internal_ip
    : workspaceConfig.ip;

const catalogEndpoint =
  typeof window === "undefined" && catalogConfig.internal_ip
    ? catalogConfig.internal_ip
    : catalogConfig.ip;

const workspaceInternalEndpoint = workspaceConfig.internal_ip
  ? workspaceConfig.internal_ip
  : workspaceConfig.ip;
const browserWorkspaceApiBasePath =
  typeof window !== "undefined"
    ? process.env.NEXT_PUBLIC_BASE_TERM
      ? `/${process.env.NEXT_PUBLIC_BASE_TERM}`
      : ""
    : "";
const browserCatalogProxyEndpoint =
  typeof window !== "undefined"
    ? `${browserWorkspaceApiBasePath}/api/catalog-proxy`
    : "";
const browserValuationProxyEndpoint =
  typeof window !== "undefined"
    ? `${browserWorkspaceApiBasePath}/api/valuation/proxy`
    : "";
const catalogServiceEndpoint =
  typeof window !== "undefined"
    ? browserCatalogProxyEndpoint
    : catalogEndpoint || process.env.NEXT_PUBLIC_ACKO_DRIVE_CATALOG_SERVICE;
const ackoEndpoint = process.env.ACKO_URL || process.env.NEXT_PUBLIC_ACKO_URL;
const valuationServiceEndpoint = typeof window !== "undefined" ? browserValuationProxyEndpoint : workspaceEndpoint;

export const MEDIA_URL = `${catalogServiceEndpoint}/media/tags/filter`;
export const EXPERT_OPINION_URL = `${catalogServiceEndpoint}/api/v1/reviews/`;
export const SEARCH_CARS_URL = `${catalogServiceEndpoint}/rest/v1/search/cars`;
export const COLOR_MEDIA_URL = `${catalogServiceEndpoint}/media/color`;
export const CITY_PRICE_URL = `${catalogServiceEndpoint}/api/pricing/nearest-cities`;
export const FILTERS_URL =
  typeof window !== "undefined"
    ? `${browserWorkspaceApiBasePath}/api/filters`
    : `${catalogServiceEndpoint}/v1/filters/`;
export const SEARCH_URL = `${catalogServiceEndpoint}/rest/v1/search`;
export const SEARCH_ARTICLES_URL = `${catalogServiceEndpoint}/rest/v1/search/articles`;
export const GRAPHQL_URL = `${catalogServiceEndpoint}/graphql`;
export const PRICE_BREAKUP_URL_V2 = `${catalogServiceEndpoint}/rest/v1/products`;
export const CATALOG_PRODUCTS_URL = `${catalogServiceEndpoint}/rest/v1/products`;
export const CATALOG_ACCESSORIES_BY_SLUG_URL = `${catalogServiceEndpoint}/api/v1/catalogue/accessories/slug`;
export const COMPARE_URL = `${catalogServiceEndpoint}/api/compare`;

export const GENERATE_TOEKN = `${workspaceEndpoint}/api/generate-tokens`;
export const SERVICE_COST_URL = `${catalogServiceEndpoint}/rest/v1/products`;
export const WISH_LIST_EXPORT_REVIEW_URL = `${catalogServiceEndpoint}/api/v1/reviews`;
// export const FAQ_URL = `${process.env.ACKO_DRIVE_WORKSPACE}/faqs/`;
// export const ALL_FAQ_LIST_URL = `${process.env.ACKO_DRIVE_WORKSPACE}/faqs/mm-sister/`;
export const VEHICLE_FEATURES_URL = `${catalogServiceEndpoint}/features/vehicle-features`;
export const EXCLUSIVE_MEDIA_URL = `${catalogServiceEndpoint}/media/exclusive`;
export const CHECK_SLUG_TYPE_URL = `${catalogServiceEndpoint}/rest/v1/search/slug-type`;
export const FETCH_EXPERT_VIDEO_ARTICLES_URL = `${workspaceEndpoint}/seo/video-articles/`;
export const FETCH_COMPONENT_BFF = `${process.env.NEXT_PUBLIC_BFF_URL}/v1/component-data`;
// Booking Service Endpoints
export const MMV_DEAL_URL = `${workspaceEndpoint}/price/mmv-deal/`;
export const FINANCE_PROVIDER_URL = `${workspaceEndpoint}/car-finance/v1/list-finance-provider`;
export const CANCELLATION_CHARGES_URL = `${workspaceEndpoint}/booking/cancellation-charges/`;
export const DRAFT_QUOTE_URL = `${workspaceEndpoint}/booking/draft-quote/v1/`;
export const CREATE_QUOTE_URL = `${workspaceEndpoint}/booking/create-quote/`;
export const CREATE_OMS_QUOTE_URL = `${process.env.NEXT_PUBLIC_OMS_WORKSPACE}/oms/v1/retail/quote`;
export const CREATE_ORDER_BOOKING_URL = `${process.env.NEXT_PUBLIC_OMS_WORKSPACE}/oms/v1/retail/orders`;
export const DYNAMIC_CONFIG_URL = `${workspaceEndpoint}/dynamic-config/v1/`;
export const CREATE_BOOKING_URL = `${workspaceEndpoint}/booking/create-booking/`;
export const CREATE_ORDER_URL = `${workspaceEndpoint}/payment/createorder/`;
export const BOOKING_DETAIL_URL = `${workspaceEndpoint}/booking/booking-detail`;
export const PAYMENT_RESPONSE_URL = `${workspaceEndpoint}/payment/payment_response/`;
export const CHECK_QUOTE_AUTH = `${workspaceEndpoint}/workspace/master/quote-auth/`;
export const EXPERT_REVIEWS_URL = `${catalogServiceEndpoint}/api/v1/reviews/`;
export const MM_GALLERY_MEDIA_URL = `${catalogServiceEndpoint}/media/filter`;
export const STANDOUT_FEATURES = `${catalogServiceEndpoint}/features/vehicle-features`;
export const WISH_LIST_GET = `${catalogServiceEndpoint}/api/wishlist`;
export const SHORTLIST_GET = `${catalogServiceEndpoint}/api/wishlist`;
export const WISH_LIST_ADD = `${catalogServiceEndpoint}/api/wishlist/add`;
export const WISH_LIST_CANADD = `${catalogServiceEndpoint}/api/wishlist/can-add`;
export const WISH_LIST_REMOVE = `${catalogServiceEndpoint}/api/wishlist/remove`;
export const WISH_LIST_REPLACE = `${catalogServiceEndpoint}/api/wishlist/replace`;
export const WISH_LIST_UPDATE_MMVC = `${catalogServiceEndpoint}/api/wishlist/update-mmvc`;
export const CITY_URL = `${workspaceEndpoint}/workspace/dealer/city-list/`;
export const CITY_URL_SERVER = `${workspaceEndpoint}/workspace/dealer/city-list/`;
export const MODEL_FEATURE_URL = `${catalogServiceEndpoint}/features/models/`;
export const VARIANT_COMPARISON_URL = (variantSlug: string) =>
  `${catalogServiceEndpoint}/features/comparisons/${variantSlug}/next`;
export const PROFILE_SHORTS_FEED_URL = `${catalogServiceEndpoint}/api/feed/items`;

export const GARAGE_SLOTS_URL = `${process.env.NEXT_PUBLIC_ACKO_GARAGE_SERVICE}/v1/garage/slots/availability`;

export const FETCH_BRANDS = `${catalogServiceEndpoint}/v1/brands/`;
export const FETCH_MODEL_BY_BRANDID = (brand_id: number) =>
  `${catalogServiceEndpoint}/v1/models/brand/${brand_id}`;
export const FETCH_VARIANTS_BY_MODEL = (brand_id: number, model_id: number) =>
  `${catalogServiceEndpoint}/make/${brand_id}/models/${model_id}/variants`;

export const FETCH_PROFILE = `${workspaceEndpoint}/api/fetch-profile/`;
export const FETCH_USER_ADDRESSES = `${process.env.NEXT_PUBLIC_ACKO_GARAGE_SERVICE}/v1/garage/users/address`;
export const SAVE_USER_ADDRESSES = `${process.env.NEXT_PUBLIC_ACKO_GARAGE_SERVICE}/v1/garage/users/address`;
export const FETCH_ADDRESS_DETAILS = `${process.env.NEXT_PUBLIC_ACKO_GARAGE_SERVICE}/v1/garage/users/google-maps/pincode`;

// Car Drop Endpoints
export const CARDROP_STATES_CAMPAIGN = `${catalogServiceEndpoint}/campaign/eligibility`;
export const CARDROP_CAMPAIGN = `${catalogServiceEndpoint}/campaign`;
export const CARDROP_CAMPAIGN_EMAIL = `${process.env.NEXT_PUBLIC_ACKO_GARAGE_SERVICE}/v1/garage/send-campaign-alert-email`;

// Lead Capture Service Endpoints
export const LEAD_CAPTURE_URL = browserWorkspaceApiBasePath
  ? `${browserWorkspaceApiBasePath}/api/partners/lead-capture/`
  : typeof window !== "undefined"
    ? `/api/partners/lead-capture/`
    : `${workspaceEndpoint}/api/partners/lead-capture/`;
export const LEAD_CAPTURE_INTERNAL_URL = `${workspaceInternalEndpoint}/api/partners/lead-capture/`;
export const CUSTOMER_STATUS_URL = `${workspaceEndpoint}/api/customer-status/`;
export const DEFAULT_LOCATION_URL = `${workspaceEndpoint}/api/default-location`;
export const VALUATION_REQUEST_CALLBACK_V2_URL = `${valuationServiceEndpoint}/car-valuation/v2/request-callback/`;
export const REQUEST_CALLBACK_URL = browserWorkspaceApiBasePath
  ? `${browserWorkspaceApiBasePath}/api/request-callback/`
  : typeof window !== "undefined"
    ? `/api/request-callback/`
    : `${workspaceEndpoint}/api/request-callback/`;
export const REQUEST_CALLBACK_INTERNAL_URL = `${workspaceInternalEndpoint}/api/request-callback/`;
export const UPSELL_ACKO_REQUEST_CALLBACK_URL = browserWorkspaceApiBasePath
  ? `${browserWorkspaceApiBasePath}/api/upsell/request-callback/`
  : typeof window !== "undefined"
    ? `/api/upsell/request-callback/`
    : "/api/upsell/request-callback/";
export const UPSELL_ACKO_REQUEST_CALLBACK_INTERNAL_BASE_URL = `${ackoEndpoint}/sdui/api/v1/ackodrive-lead`;
export const REVERSE_GEOCODE_URL = `${catalogServiceEndpoint}/api/geocoding/reverse`;
export const CUSTOMER_STATUS_INTERNAL_URL = `${workspaceInternalEndpoint}/api/customer-status/`;

// Coupon Service Endpoints
export const USER_COUPONS = `${workspaceEndpoint}/workspace/master/coupons/user/`;
export const COUPON_VALIDITY = `${workspaceEndpoint}/workspace/master/coupons/check/`;
export const APPLY_COUPON = `${workspaceEndpoint}/workspace/master/coupons/apply/`;
export const APPLIED_COUPONS = `${workspaceEndpoint}/workspace/master/coupons/quote/`;
export const REMOVE_COUPONS = `${workspaceEndpoint}/workspace/master/coupons/remove-quote/`;
export const ENCRYPT = `${workspaceEndpoint}/api/encrypt/`;

// New Coupon Endpoints
export const FETCH_COUPONS = `${process.env.NEXT_PUBLIC_OMS_WORKSPACE}/oms/v1/retail/rewards/fetch`;
export const REVOKE_COUPONS = `${process.env.NEXT_PUBLIC_OMS_WORKSPACE}/oms/v1/retail/rewards/revoke-coupon`;
export const APPLY_COUPON_NEW = `${process.env.NEXT_PUBLIC_OMS_WORKSPACE}/oms/v1/retail/rewards/apply-coupon`;

// OMS Endpoints
export const OMS_BOOKING_DETAIL_URL = `${process.env.NEXT_PUBLIC_OMS_WORKSPACE}/oms/v1/retail/orders/old-details`;
export const OMS_UPLOAD_KYC_URL = `${process.env.NEXT_PUBLIC_OMS_WORKSPACE}/oms/v1/orders/upload`;
export const OMS_LOAN_DOCUMNETS = `${process.env.NEXT_PUBLIC_OMS_WORKSPACE}/oms/v1/loan/retail/details`;
export const OMS_GET_LOAN_DOCUMNETS = `${process.env.NEXT_PUBLIC_OMS_WORKSPACE}/oms/v1/loan/retail/documents`;
export const OMS_GET_ALL_BOOKINGS = `${process.env.OMS_WORKSPACE_SERVER}/oms/v1/retail/orders/bookings-user`;
export const OMS_BOOKINGS_USER_URL = `${process.env.OMS_WORKSPACE_SERVER}/oms/v1/retail/orders/bookings-user`;
export const OMS_ORDER_BASE_URL = `${process.env.OMS_WORKSPACE_SERVER}/oms/v1/retail/orders`;
export const OMS_QUOTES_USER_URL = `${process.env.OMS_WORKSPACE_SERVER}/oms/v1/retail/quote/quotes-user`;

// Valuation Report Endpoints
export const RECENT_VALUATIONS_URL = `${valuationServiceEndpoint}/car-valuation/v1/recent-searches/`;
export const VALUATION_REPORT_DATA_URL = `${valuationServiceEndpoint}/car-valuation/v1/generate-valuation-report`;
export const GENERATE_VALUATION_REPORT_ASYNC_URL = `${valuationServiceEndpoint}/car-valuation/v1/generate-valuation-report-async`;
export const UPDATE_VALUATION_REPORT_URL = `${valuationServiceEndpoint}/car-valuation/v1/update-valuation-report`;
export const DECRYPT_VALUE_URL = `${workspaceEndpoint}/api/decrypt/`;
export const AADRILLA_DETAILS_URL = `${valuationServiceEndpoint}/car-details/v2/`;
export const UPDATE_VALUATION_DETAILS_URL = `${valuationServiceEndpoint}/car-valuation/v1/`;
export const VALUATION_CITIES_URL = `${valuationServiceEndpoint}/car-valuation/v1/valuation-city/`;
export const VALUATION_SLOTS_URL = `${valuationServiceEndpoint}/car-valuation/v1/slot-availability/`;
export const VALUATION_INSPECTION_URL = `${valuationServiceEndpoint}/car-valuation/v1/inspection/`;
export const VALUATION_LEAD_URL = `${valuationServiceEndpoint}/car-valuation/v1/valuation-lead`;
export const GET_VALUATION_DETAILS = `${workspaceEndpoint}/car-valuation/v1/valuation/`;
export const GET_PLACE_DETAILS_URL = `${workspaceEndpoint}/service/place-details`;

export const FRONTEND_CAR_VALUATION_CITIES_URL = `${browserValuationProxyEndpoint}/car-valuation/v1/valuation-city/`;
export const FRONTEND_CAR_VALUATION_MAKES_URL = `${browserWorkspaceApiBasePath}/api/valuation/car-valuation/makes`;
export const FRONTEND_CAR_VALUATION_MODELS_URL = `${browserWorkspaceApiBasePath}/api/valuation/car-valuation/models`;
export const FRONTEND_CAR_VALUATION_VARIANTS_URL = `${browserWorkspaceApiBasePath}/api/valuation/car-valuation/variants`;

// Catalog Service Pricing Endpoint
export const CATALOG_PRICING_URL = `${catalogServiceEndpoint}/rest/v1/products`;

// Asset Service Endpoints - Central
export const ASSETS_MAKES_URL = `${process.env.NEXT_PUBLIC_AUTO_ASSET_SERVICE}/asset_service/api/assets/vehicle-resolution/vehicles/makes`;
export const ASSETS_MODELS_URL = `${process.env.NEXT_PUBLIC_AUTO_ASSET_SERVICE}/asset_service/api/assets/vehicle-resolution/vehicles/models`;
export const ASSETS_VARIANTS_URL = `${process.env.NEXT_PUBLIC_AUTO_ASSET_SERVICE}/asset_service/api/assets/vehicle-resolution/vehicles/variants`;
export const ASSETS_CREATE_V2_URL = `${process.env.NEXT_PUBLIC_AUTO_ASSET_SERVICE}/asset_service/api/v2/assets/create/vehicle`;
export const FRONTEND_ASSETS_CREATE_V2_URL = `${browserWorkspaceApiBasePath}/api/assets/create`;
